
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Trash2, GripVertical } from 'lucide-react';
import { PlanFeature } from '@/hooks/license/resellerPlans/types';

interface FeatureItemProps {
  feature: PlanFeature;
  index: number;
  onUpdateFeature: (index: number, updatedFeature: PlanFeature) => void;
  onDeleteFeature: (index: number) => void;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ 
  feature, 
  index, 
  onUpdateFeature, 
  onDeleteFeature 
}) => {
  return (
    <div className="flex items-center space-x-3 p-2">
      <div className="text-gray-400 cursor-move">
        <GripVertical className="h-4 w-4" />
      </div>
      
      <Input 
        value={feature.name} 
        onChange={(e) => {
          onUpdateFeature(index, {
            ...feature,
            name: e.target.value
          });
        }}
        className="flex-grow"
      />
      
      <div className="flex items-center space-x-2">
        <label className="text-sm">Included</label>
        <input 
          type="checkbox" 
          checked={feature.included} 
          onChange={(e) => {
            onUpdateFeature(index, {
              ...feature,
              included: e.target.checked
            });
          }}
          className="h-4 w-4"
        />
      </div>
      
      <div className="flex items-center space-x-2">
        <label className="text-sm">Highlight</label>
        <input 
          type="checkbox" 
          checked={feature.highlight || false} 
          onChange={(e) => {
            onUpdateFeature(index, {
              ...feature,
              highlight: e.target.checked
            });
          }}
          className="h-4 w-4"
        />
      </div>
      
      <Button 
        variant="destructive" 
        size="icon"
        onClick={() => onDeleteFeature(index)}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default FeatureItem;
